module.exports = __webpack_public_path__ + "img/GAL1.c2435ce7.jpg";